import { EDGE_STYLES, NODE_LABELS, STARTER_NODE_POSITION, STARTER_NODE_UI_ID } from "./ruleBasedFlow.constants";

/**
 * Creates a UI-only starter node
 */
export const createStarterNode = (handleStarterClick) => ({
  id: STARTER_NODE_UI_ID,
  type: "starterNode",
  position: STARTER_NODE_POSITION,
  data: {
    onClick: (e) => {
      e.stopPropagation();
      handleStarterClick(e); // Pass event to get position
    },
  },
  draggable: false,
});

/**
 * Transforms MongoDB nodes to React Flow format
 */
export const transformMongoNodesToReactFlow = (nodes, handleNodeAddClick, handleDeleteNode, handleUpdateNodeDataEmail, handleUpdateNodeData) => {
  return nodes.map((node) => ({
    id: node._id,
    type: node.type,
    position: node.position,
    data: {
      ...node.data,
      onAddNode: handleNodeAddClick,
      onDeleteNode: handleDeleteNode,
      onUpdateNodeData: handleUpdateNodeData,
      emailTemplate: node.emailTemplate,
      onUpdateNodeDataEmail: handleUpdateNodeDataEmail,
      isFirstNode: node.isFirstNode, // Preserve isFirstNode flag from MongoDB
      isCompleted: node.isCompleted, // Preserve isCompleted flag from MongoDB
    },
  }));
};

/**
 * Creates a UI-only edge from starter to first node
 */
export const createStarterEdge = (targetNodeId) => ({
  id: `${STARTER_NODE_UI_ID}-${targetNodeId}`,
  source: STARTER_NODE_UI_ID,
  sourceHandle: "bottom",
  target: targetNodeId,
  animated: false,
  type: "interactive", // Use interactive edge type
  style: EDGE_STYLES.STARTER_EDGE,
});

/**
 * Creates a regular edge between two nodes
 */
export const createEdge = (sourceId, targetId, sourceHandle, animated = false) => ({
  id: `${sourceId}-${targetId}`,
  source: sourceId,
  sourceHandle: sourceHandle,
  target: targetId,
  animated: animated,
  type: "interactive", // Use custom interactive edge
});

/**
 * Creates payload for addNode API
 */
export const createAddNodePayload = (workflowId, nodeType, position, isFirstNode) => ({
  workflowId: parseInt(workflowId),
  type: nodeType,
  data: {
    label: NODE_LABELS[nodeType] || nodeType,
  },
  position: position,
  edges: [],
  calculationNodeRef: null,
  isCompleted: false,
  isFirstNode: isFirstNode,
});

/**
 * Creates payload for addTaskNode API
 */
export const createAddTaskNodePayload = (entityId, nodeType, position, isFirstNode) => {
  return {
    taskId: parseInt(entityId),
    type: nodeType,
    data: { label: NODE_LABELS[nodeType] || nodeType },
    position,
    isFirstNode,
  };
};

/**
 * Creates payload for addNodeEdge API (workflow context)
 */
export const createAddEdgePayload = (sourceNodeId, targetNodeId, workflowId, sourceHandle) => ({
  nodeId: sourceNodeId,
  workflowId: parseInt(workflowId),
  source: sourceNodeId,
  target: targetNodeId,
  sourceHandle: sourceHandle,
  type: "interactive",
});

/**
 * Creates payload for addTaskNodeEdge API (task context)
 */
export const createAddTaskEdgePayload = (sourceNodeId, targetNodeId, taskId, sourceHandle) => ({
  nodeId: sourceNodeId,
  taskId: parseInt(taskId),
  source: sourceNodeId,
  target: targetNodeId,
  sourceHandle: sourceHandle,
  type: "interactive",
});

/**
 * Finds the first node from a list of nodes
 */
export const findFirstNode = (nodes) => {
  return nodes.find((node) => node.isFirstNode);
};

/**
 * Gets menu position (always returns fixed position)
 */
export const getMenuPosition = () => {
  return { x: 0, y: 0 };
};
